export default [
  {
    label: '速通卡',
    value: '速通卡',
  },
  {
    label: '河北-低碳畅行卡',
    value: '低碳畅行卡',
  },
  {
    label: '山西-快通卡',
    value: '快通卡',
  },
  {
    label: '内蒙古-蒙通卡',
    value: '蒙通卡',
  },
  {
    label: '辽宁-辽通卡',
    value: '辽通卡',
  },
  {
    label: '吉林-吉通卡',
    value: '吉通卡',
  },
  {
    label: '黑龙江-龙通卡',
    value: '龙通卡',
  },
  {
    label: '上海-沪通卡',
    value: '沪通卡',
  },
  {
    label: '江苏-苏通卡',
    value: '苏通卡',
  },
  {
    label: '浙江-浙通卡',
    value: '浙通卡',
  },
  {
    label: '安徽-慧易通',
    value: '慧易通',
  },
  {
    label: '福建-闽通卡',
    value: '闽通卡',
  },
  {
    label: '江西-赣通卡',
    value: '赣通卡',
  },
  {
    label: '山东-鲁通卡',
    value: '鲁通卡',
  },
  {
    label: '河南-中原通',
    value: '中原通',
  },
  {
    label: '湖北-鄂通卡',
    value: '鄂通卡',
  },
  {
    label: '湖南-湘通卡',
    value: '湘通卡',
  },
  {
    label: '广东-粤通卡',
    value: '粤通卡',
  },
  {
    label: '广西-八桂行卡',
    value: '八桂行卡',
  },
  {
    label: '重庆-通渝卡',
    value: '通渝卡',
  },
  {
    label: '四川-蜀通卡',
    value: '蜀通卡',
  },
  {
    label: '贵州-黔通卡',
    value: '黔通卡',
  },
  {
    label: '云南-云通卡',
    value: '云通卡',
  },
  {
    label: '陕西-三秦通',
    value: '三秦通',
  },
  {
    label: '甘肃-陇通卡',
    value: '陇通卡',
  },
  {
    label: '青海-青通卡',
    value: '青通卡',
  },
  {
    label: '宁夏-宁通卡',
    value: '宁通卡',
  },
  {
    label: '新疆-天山行卡',
    value: '天山行卡',
  },
];
